var _desc, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPosition2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10 by 10 orthogonal maze") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "10 by 10 orthogonal maze generated by The Maze Generator Website (https://www.mazegenerator.net/).")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 81.372,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 2,
    x2: 162,
    y2: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.251 17.999 L 98 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 18,
    x2: 146,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 34,
    x2: 130,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 34,
    x2: 162,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.024,
    y1: 66.031,
    x2: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 50,
    x2: 146,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 66,
    x2: 114,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 66,
    x2: 162,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.856,
    y1: 81.972,
    x2: 66,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 82,
    x2: 98,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 82,
    x2: 146,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 98,
    x2: 82,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 98,
    x2: 114,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 98,
    x2: 146,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.934,
    y1: 113.94,
    x2: 34.027,
    y2: 114.008
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 114,
    x2: 98,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 130,
    x2: 82,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 130,
    x2: 162,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 146,
    x2: 66,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 146,
    x2: 146,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 162,
    x2: 82,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.274,
    y1: 162.065,
    x2: 162,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 2.226,
    y2: 145.068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 2,
    x2: 18,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 50,
    x2: 18,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.096,
    y1: 97.669,
    x2: 18,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.957,
    y1: 130.903,
    x2: 17.881,
    y2: 145.002
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 18,
    x2: 34,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 82,
    x2: 34,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 114,
    x2: 34,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.931,
    y1: 18.04,
    x2: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 82,
    x2: 49.919,
    y2: 129.867
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 18,
    x2: 66,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 66,
    x2: 82,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 98,
    x2: 82,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 130,
    x2: 82,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 82,
    x2: 98,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 114,
    x2: 98,
    y2: 146
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113.971 17.972 C 113.971 23.838 114.023 40.713 114.023 30.847"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 66,
    x2: 114,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 98,
    x2: 114,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 34,
    x2: 130,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 114,
    x2: 130,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 82,
    x2: 146,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.517,
    y1: 17.603,
    x2: 162,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.217,
    y1: 114.135,
    x2: 18,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.353,
    y1: 145.094,
    x2: 17.881,
    y2: 145.002
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 82,
    x2: 18.107,
    y2: 81.925
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.85,
    y1: 34.067,
    x2: 18,
    y2: 34
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03019, 0, 0, 0.028854, -0.346778, 143.257126)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 2468.197 -300.281 C 2484.713 -298.943 2499.02 -311.214 2500.357 -327.673 C 2501.636 -344.131 2489.365 -358.437 2472.849 -359.833 C 2456.507 -361.054 2442.085 -348.783 2440.863 -332.325 C 2439.467 -315.983 2451.738 -301.561 2468.196 -300.281"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 2442.897 -288.011 C 2448.771 -292.14 2455.924 -294.873 2463.891 -294.175 C 2474.127 -293.361 2482.501 -287.022 2487.619 -279.287 L 2517.744 -219.561 L 2558.86 -191.239 C 2562.349 -188.564 2564.559 -184.203 2564.094 -179.433 C 2563.512 -172.048 2557.057 -166.522 2549.671 -167.162 C 2547.403 -167.279 2545.542 -168.209 2543.506 -169.14 L 2498.668 -200.021 C 2497.273 -201.126 2496.168 -202.521 2495.237 -203.975 L 2484.013 -226.365 L 2470.463 -166.813 L 2523.443 -104.237 C 2524.664 -102.318 2525.479 -100.05 2525.944 -97.782 L 2540.25 -22.237 C 2540.134 -20.551 2540.366 -19.504 2540.25 -18.166 C 2539.436 -6.884 2529.666 1.258 2518.558 0.444 C 2509.311 -0.312 2502.507 -7.116 2500.355 -15.549 L 2486.863 -86.325 L 2443.769 -133.431 L 2433.824 -87.546 C 2433.475 -85.394 2430.626 -80.858 2429.811 -79.055 L 2388.462 -9.384 C 2384.391 -3.045 2377.47 1.026 2369.62 0.386 C 2358.396 -0.428 2350.08 -10.198 2351.01 -21.364 C 2351.243 -24.505 2352.581 -27.819 2353.744 -30.088 L 2392.127 -94.467 L 2424.171 -236.367 L 2403.235 -219.444 L 2392.127 -168.906 C 2390.615 -162.392 2384.741 -157.1 2377.821 -157.624 C 2370.319 -158.205 2364.852 -164.66 2365.434 -172.163 C 2365.434 -172.744 2365.55 -173.326 2365.666 -174.024 L 2378.809 -232.936 C 2379.623 -235.436 2380.961 -237.704 2382.938 -239.449 L 2442.897 -288.009 L 2442.897 -288.011 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition2);
export default __webpack_public_path__ + "static/media/Position2.8d50e5d774ee28c4eaef4b679ab68949.svg";
export { ForwardRef as ReactComponent };